import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { mergeTranslations } from "./utils/utilsTranslations";

//Import all translation files
import translationEnglish from "./translation/en.json";
import translationItalian from "./translation/it.json";

const customFolder = process.env.REACT_APP_CUSTOM_TRANSLATION?.trim();
let customTranslations: WebpackRequireContext | undefined;
try {
  customTranslations = require.context(
    "./translation",
    true,
    /^\.\/.+\/.+\.json$/,
  );
} catch {
  customTranslations = undefined;
}

const getCustomTranslation = (language: string) => {
  if (!customFolder || !customTranslations) return undefined;
  const path = `./${customFolder}/${language}.json`;
  return customTranslations.keys().includes(path)
    ? customTranslations(path)
    : undefined;
};

//---Using different namespaces
const resources = {
  en: mergeTranslations(translationEnglish, getCustomTranslation("en")),
  it: mergeTranslations(translationItalian, getCustomTranslation("it")),
};

const LANGUAGE_STORAGE_KEY = "display-lang";
const supportedLanguages = Object.keys(resources);
const storedLanguage = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
const initialLanguage =
  storedLanguage && supportedLanguages.includes(storedLanguage)
    ? storedLanguage
    : "it";

i18next.use(initReactI18next).init({
  fallbackLng: "it",
  defaultNS: "it",
  resources,
  lng: initialLanguage,
});

i18next.on("languageChanged", (lng) => {
  sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
});

export default i18next;
